import {Component, EventEmitter, Input, Output, ViewChild} from "@angular/core";
import {Company} from "../../../entities/company";
import {ModalComponent} from "../../modal/modal.component";
import {DocumentService} from "../../../services/document.service";
import {SharedService} from "../../../services/sharedService";
import {ToastrService} from "ngx-toastr";

@Component({
    selector: "app-company-document-upload",
    template: `
        <app-modal #companyAddDocument [size]="'large'" [scrollable]="true">
            <app-modal-header>{{ 'COMPANY.UPLOAD_DOCUMENT' | translate }}
            </app-modal-header>
            <app-modal-body>
                <div class="container">
                    <p-fileUpload *ngIf="company"
                            #uploader
                            class="cloud-upload"
                            name="file"
                            [url]="_.apiUrl('api/documents', 'payee/' + company.id)"
                            [customUpload]="false"
                            [multiple]="false"
                            (uploadHandler)="uploadHandler($event)"
                            [auto]="true"
                            [showUploadButton]="true"
                            [showCancelButton]="true"
                            [maxFileSize]="5000000"
                            (onUpload)="onUpload($event)"
                            accept=".jpg,.png,.pdf,.xls,.xlsx"
                    >
                        <ng-template pTemplate="content" let-files>
                            <div class="cloud-drop-area" (click)="uploader.choose()">
                                <i class="pi pi-cloud-upload cloud-icon"></i>

                                <div class="cloud-title">Drop files here</div>
                                <div class="cloud-subtitle">or click to browse from your device</div>

                                <ul class="file-list" *ngIf="files?.length">
                                    <li *ngFor="let file of files">
                                        {{ file.name }} ({{ file.size / 1024 | number:'1.0-0' }} KB)
                                    </li>
                                </ul>
                            </div>
                        </ng-template>
                    </p-fileUpload>
                </div>
            </app-modal-body>
            <app-modal-footer>
            </app-modal-footer>
        </app-modal>
    `,
    styleUrls: ['./company-document-upload.component.css']
})
export class CompanyDocumentUploadComponent {

    @Input() company: Company;
    @ViewChild('companyAddDocument', {static: true})
    public modal: ModalComponent
    @Output() uploaded: EventEmitter<any> = new EventEmitter();
    // files = [];

    constructor(private documentService: DocumentService,
                protected _: SharedService,
                private alertService: ToastrService) {
    }

    uploadHandler(event: any) {
        // const formData = new FormData();
        // this.files = event.files as File[];
        //
        // for (const file of this.files) {
        //     formData.append('files', file, file.name);
        // }

        // this.documentService.add$('payee', this.company.id, event.files[0]).subscribe({
        //     next: () => {
        //         // clear UI after success
        //         event.options.clear();
        //         this.files = [];
        //         this.uploaded.emit(true);
        //     },
        //     error: err => {
        //         console.error('Upload error', err);
        //     }
        // })
        console.log('selected', event.files)
    }

    onUpload(event: any) {
        this.alertService.success("Document uploaded successfully!");
        this.uploaded.emit(true);
        this.hide()
    }

    show() {
        this.modal.show()
    }

    hide() {
        this.modal.hide()
    }

}